import { render, staticRenderFns } from "./v-calendar-manager.vue?vue&type=template&id=1d752fa2&"
import script from "./v-calendar-manager.vue?vue&type=script&lang=js&"
export * from "./v-calendar-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports